import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

const API_URL = config.API_URL + '/matches';

class MatchService {
    getAllMatches() {
        return axios.get(API_URL, { headers: authHeader() });
    }

    getMatchById(id) {
        return axios.get(API_URL + '/' + id, { headers: authHeader() });
    }

    createMatch(matchData) {
        return axios.post(API_URL, matchData, { headers: authHeader() });
    }

    updateMatch(id, matchData) {
        return axios.put(API_URL + '/' + id, matchData, { headers: authHeader() });
    }

    deleteMatch(id) {
        return axios.delete(API_URL + '/' + id, { headers: authHeader() });
    }

    getMatchesByUser(userId) {
        return axios.get(API_URL + '/user/' + userId, { headers: authHeader() });
    }

    validateMatch(id) {
        return axios.put(API_URL + '/' + id + '/validate', {}, { headers: authHeader() });
    }
}

export default new MatchService(); 